if (!customElements.get("social-media-highlights-slider")) {
	class SocialMediaHighlightsSlider extends HTMLElement {
		constructor() {
			super();

			/** Store Content Card before initilation */
			this.slideContent = this.querySelector(
				".section__social-media-highlights--content-card"
			);

			/** Swiper opts & init */
			const swiperOptions =
				JSON.parse(this.getAttribute("data-swiper-options")) || {};
			const swiperLayout =
				this.getAttribute("data-swiper-layout") || "default";

			this.sliderItem = this.querySelector(".swiper");

			this.sliderOptions = {
				slidesPerView: swiperOptions.slidesPerViewMobile || 1,
				centeredSlides: true,
				spaceBetween: swiperOptions.spaceBetweenMobile || 2,
				loop: true,
				loopedSlides: 8,
				loopFillGroupWithBlank: false,
				watchSlidesProgress: true,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				breakpoints: {
					750: {
						slidesPerView:
							swiperOptions.slidesPerViewDesktop || 3.5,
						spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
						centeredSlides: true,
						loop: true,
					},
					1100: {
						slidesPerView:
							swiperOptions.slidesPerViewDesktop || 3.5,
						spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
						centeredSlides: true,
						loop: true,
					},
				},
				on: {
					afterInit: () => {
						this.querySelector(".swiper-smh").removeAttribute(
							"style"
						);
						// Force update to ensure preview shows immediately
						if (this.swiper) {
							this.swiper.update();
							this.swiper.updateSlides();
						}
					},
					transitionEnd: () => {
						// Force loop update when transition ends
						if (this.swiper && this.swiper.loop) {
							this.swiper.loopDestroy();
							this.swiper.loopCreate();
							this.swiper.update();
							// Force position update
							setTimeout(() => {
								this.swiper.updateSize();
								this.swiper.updateSlides();
							}, 10);
						}
					},
				},
			};

			if (
				swiperOptions.autoplaySpeed != 0 &&
				swiperLayout === "default"
			) {
				this.sliderOptions = {
					speed: swiperOptions.autoplaySpeed || 10000,
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					},
					...this.sliderOptions,
				};
			}

			if (swiperLayout === "default") {
				this.sliderOptions = {
					loop: true,
					...this.sliderOptions,
				};
			}

			// Force loop on mobile for all layouts
			this.sliderOptions = {
				loop: true,
				...this.sliderOptions,
			};

			if (swiperLayout === "stacked") {
				this.sliderOptions = {
					navigation: {
						prevEl: ".swiper-button--prev",
						nextEl: ".swiper-button--next",
					},
					...this.sliderOptions,
				};
			}

			if (Shopify.designMode) {
				window.addEventListener(
					"shopify:section:load",
					this.init.bind(this)
				);
			}
		}

		connectedCallback() {
			this.init();
		}

		init() {
			this.swiper = new Swiper(this.sliderItem, this.sliderOptions);
			this.toggleSlideContentCard();

			// Force loop initialization and positioning
			requestAnimationFrame(() => {
				if (this.swiper) {
					this.swiper.loopDestroy();
					this.swiper.loopCreate();
					this.swiper.update();
					// Position to show the preview properly
					this.swiper.slideToLoop(0, 0);
				}
			});
		}

		/** Hide / Show Content Card */
		toggleSlideContentCard() {
			let swiperInitialized = false;
			if (window.innerWidth < 750) {
				this.swiper.removeSlide(2);
			}

			const updateSlideContent = () => {
				if (swiperInitialized) {
					if (window.innerWidth < 750) {
						this.swiper.removeSlide(2);
					} else {
						this.swiper.addSlide(2, this.slideContent);
					}
				}
			};

			updateSlideContent();

			window.addEventListener(
				"resize",
				debounce(() => {
					updateSlideContent();
				}, 200)
			);

			this.addEventListener("swiper:init", () => {
				swiperInitialized = true;
			});
		}
	}

	customElements.define(
		"social-media-highlights-slider",
		SocialMediaHighlightsSlider
	);
}
